module.exports = __webpack_public_path__ + "img/益视说明书_00.b07d6d7f.png";